import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostImage(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostImageInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostImage,
      parentId,
      masterBlockId,
    ),
    border: {
      radius: 3,
      width: 1,
      style: BorderStyleEnum.none,
    },
  }
}
